export default class Customer {
  constructor(API) {
    this.api = API;
  }
  /*
  {
    id: 'validString',
    adminRole: 'validString',
    instructorRole: 'optionalValidString',
    orgAdminRole: 'optionalValidString',
    orgSubAdminRole: 'optionalValidString',
    userRole: 'validString',
    idmKey: 'validString',
    idmToken: 'validString',
    idmAPIUser: 'validString',
    idmAPIPassword: 'validString',
    mailerSender: 'validString',
    allowedOnlineCourseProviders: [ 'validString' ],
    allowedForeignReqs: [ 'validString' ],
    sharedModuleLicenseAPIKey: 'validString',
    sharedModuleClassroomAPIKey: 'validString',
    sharedModuleOrganizationAPIKey: 'validString',
    portalConfig: { //params are optional for now
      theme: 'validString',
      domain: 'validString',
      cookiesHubDomain: 'validString',
      acceptConnectionsFrom: 'validString'
    }
  }
  */
  async createCustomer(customerObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = `/customer/new`;
    req.body = customerObj;
    return await req.exec();
  }
  async updateCustomer(customerObj) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = `/customer/${customerObj.id || this.api.config.customerID}`;
    req.body = customerObj;
    return await req.exec();
  }
  async deleteCustomer(customerID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = `/customer/${customerID || this.api.config.customerID}`;
    return await req.exec();
  }
  async getCustomer(customerID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/customer/${customerID || this.api.config.customerID}`;
    return await req.exec();
  }
  async getAllCustomers() {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/customers`;
    return await req.exec();
  }
}
